/* Crumpaw · US spelling for text written after the page loads: the cart drawer on every
   page, the cart page, and on product and cart pages the variant picker and search
   dropdown, which arrive without passing through snippets/cp-us-spelling.liquid.
   Loaded by layout/theme.liquid only when the country is US. Changes the words on screen,
   never a value. Skips cp-cart-props__val: that is the customer's own text and what gets
   engraved, so "Harbour" stays "Harbour". The live previews are outside the scope for the
   same reason. */
(function () {
  var template = document.currentScript ? document.currentScript.getAttribute('data-template') : '';
  var SCOPE = 'cp-cart-drawer';
  if (template === 'cart') SCOPE += ', main, .predictive-search-dropdown';
  if (template === 'product') SCOPE += ', variant-picker, .predictive-search-dropdown';
  var NEVER = '.cp-cart-props__val, script, style, textarea, template, noscript';
  var ATTRS = ['alt', 'aria-label', 'title', 'placeholder'];
  var SWAPS = [
    [/\b([Pp])ersonalis/g, '$1ersonaliz'],
    [/\bPERSONALIS/g, 'PERSONALIZ'],
    [/\b([Cc])olour/g, '$1olor'],
    [/\bCOLOUR/g, 'COLOR'],
    [/\b([Mm])ulticolour/g, '$1ulticolor'],
    [/\b([Ww])atercolour/g, '$1atercolor'],
    [/\bSlate Grey\b/g, 'Slate Gray'],
    [/\bGrey French/g, 'Gray French'],
    [/\bgrey\b/g, 'gray'],
    [/\bgreyscale\b/g, 'grayscale'],
    [/\b([Mm])oulded/g, '$1olded'],
    [/\b([Ll])abelled/g, '$1abeled'],
    [/\bcentred\b/g, 'centered'],
    [/\bdispatched\b/g, 'shipped'],
    [/\bmobile number\b/g, 'phone number']
  ];

  function swap(text) {
    var after = text;
    for (var i = 0; i < SWAPS.length; i++) after = after.replace(SWAPS[i][0], SWAPS[i][1]);
    return after;
  }

  function inScope(el) {
    return !!el && !!el.closest && !!el.closest(SCOPE) && !el.closest(NEVER);
  }

  function fixText(node) {
    var parent = node.parentNode;
    if (!node.nodeValue || !inScope(parent)) return;
    var after = swap(node.nodeValue);
    if (after !== node.nodeValue) node.nodeValue = after;
  }

  function fixAttrs(el) {
    if (!inScope(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var before = el.getAttribute(ATTRS[i]);
      if (!before) continue;
      var after = swap(before);
      if (after !== before) el.setAttribute(ATTRS[i], after);
    }
  }

  function walk(root) {
    if (root.nodeType === 3) return fixText(root);
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (root.nodeType === 1) fixAttrs(root);
    var tree = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    var node;
    while ((node = tree.nextNode())) {
      if (node.nodeType === 3) fixText(node);
      else fixAttrs(node);
    }
  }

  function start() {
    walk(document.body);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'characterData') fixText(r.target);
        else if (r.type === 'attributes') fixAttrs(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
